import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Pays } from '../../intervenant/models/pays.model';

export class AcheteurExport {
    static readonly jsonMap = {
        id: { key: 'id', optional: true },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        pays: { key: 'idPays', converter: new (DataIdConverterFactory.build(Pays, 'pays'))(), optional: true }
    };

    id: number;
    raisonSociale: string;
    adresse: string;
    codePostal: string;
    ville: string;
    pays: Pays;
}
